module.exports = __webpack_public_path__ + "img/ic_topic_recipe-active.5f852175.svg";